import Image from "next/image";

function NoItem({ text, smallPadding }: { text: string; smallPadding?: boolean }) {
  return (
    <div className={`flex flex-col items-center ${smallPadding ? "py-[16px]" : "py-[156px]"} `}>
      <div className="relative mb-12 h-64 w-64">
        <Image src="/assets/sad.svg" fill alt="موردی یافت نشد" />
      </div>
      <p className="text-14 leading-24 text-gray-7C7C7C">{text}</p>
    </div>
  );
}

export default NoItem;
